import React, {useState} from 'react';
import {Menu} from '@mui/material';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import {toTestId} from '../utility/testIdUtil';

const AdmicityContextMenu = ({title, icon, menuItems}) => {
    const [actionContextMenuAnchor, setActionContextMenuAnchor] = useState(null);

    const handleCloseActionContextMenu = () => {
        setActionContextMenuAnchor(null);
    };

    const handleOpenActionContextMenu = (event) => {
        setActionContextMenuAnchor(event.currentTarget);
    };

    return (
        <>
            <IconButton
                aria-label={title}
                data-testid={toTestId('menu', title)}
                onClick={handleOpenActionContextMenu}
            >
                {icon}
            </IconButton>
            <Menu anchorEl={actionContextMenuAnchor}
                  open={Boolean(actionContextMenuAnchor)}
                  onClose={handleCloseActionContextMenu}>
                {menuItems}
            </Menu>
        </>
    );
};

AdmicityContextMenu.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.node,
    menuItems: PropTypes.array,
};

export default AdmicityContextMenu;